<template>
  <v-flex>
    <v-flex style="border-bottom: 1px solid black">
      <v-flex xs12 md px-1 mt-3>
        As the Parent/Legal Guardian of the Student, I attest* that I am a resident of the State of Arizona and submit in support of this attestation a copy of the following document that displays my name and residential address or physical description of the property where the student resides:
        <v-radio-group :rules="validationRules" v-model="doc_type">
          <v-radio
            label="Valid Arizona driver’s license, Arizona identification card or motor vehicle registration"
            value="drivers_license"
          ></v-radio>
          <v-radio 
            label="Valid Arizona Address Confidentiality Program authorization card"
            value="az_address_confidentiality_prog_card"
          ></v-radio>
          <v-radio
            label="Real estate deed or mortgage documents"
            value="real_estate_docs"
          ></v-radio>
          <v-radio label="Property tax bill" value="prop_tax_bill"></v-radio>
          <v-radio
            label="Residential lease or rental agreement"
            value="rental_agreement"
          ></v-radio>
          <v-radio
            label="Water, electric, gas, cable, or phone bill"
            value="util_bill"
          ></v-radio>
          <v-radio label="Bank or credit card statement" value="bank_or_CC_statement"></v-radio>
          <v-radio label="W-2 wage statement" value="w2"></v-radio>
          <v-radio label="Payroll stub" value="pay_stub"></v-radio>
          <v-radio
            label="Certificate of tribal enrollment (506 Form) or other identification issued by a recognized Indian tribe in Arizona"
            value="form_506"
          ></v-radio>
          <v-radio
            label="Documentation from a state, tribal or federal government agency (Social Security Administration, Veteran’s Administration, Arizona Department of Economic Security)"
            value="legit_docs"
          ></v-radio>
          <v-radio
            label="Temporary on-base billeting facility (for military families)"
            value="military_docs"
          ></v-radio>
          <v-radio
            label="I am currently unable to provide any of the foregoing documents. Therefore, I have provided an original affidavit signed and notarized by an Arizona resident who attests that I have established residence in Arizona with the person signing the affidavit."
            value="notarized_affidavit"
          ></v-radio>
        </v-radio-group>
        <v-flex pb-5><h5>*For members of the armed services, the provision of verifiable documentation does not serve as a declaration of official residency for income tax or other legal purposes. Armed service members may utilize a temporary on- base billeting facility as the address for proof of residency.</h5></v-flex>
      </v-flex>
    </v-flex>
  </v-flex>
</template>


<script>
export default {
  props: {},
  data() {
    return {
      validationRules: [v => !!v || "Field is required"]
    };
  },
  computed: {
    doc_type: {
      get() {
        return this.$store.state.registration.partCInfo.doc_type;
      },
      set(value) {
        this.$store.commit("registration/azResidencyDocs/setDocType", value);
      }
    }
  }
};
</script>
